import React from 'react';

import ListResource from './ListResource.jsx';
import ListCtrlActivates from './ListCtrlActivates.jsx';

const api = '/api/core/collaborators';

const ListCollaborators = () => (
    <ListResource
      {...{
        searchable: true,
        api,
        sort: { name: 1 },
        actions: {
          fileExport: 'export/csv',
        },
        cols: [
          { key: 'name', children: 'Collaborator', sortable: true },
          { key: 'designSize', children: 'Designs', sortable: true },
          { key: 'collSize', children: 'Collections', sortable: true },
        ],
      }}>
      {({ selected, refresh }) => (
        <>
          <ListCtrlActivates api={api} selected={selected} onSuccess={refresh} />
        </>
      )}
    </ListResource>
);

export default ListCollaborators;
